import { render, staticRenderFns } from "./SemicircleProgressBar.vue?vue&type=template&id=839bc1b2&"
import script from "./SemicircleProgressBar.vue?vue&type=script&lang=js&"
export * from "./SemicircleProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports